import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withKeys as _withKeys, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, Teleport as _Teleport, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../public/icons/models/close.svg'


const _withScopeId = (n: any) => (_pushScopeId("data-v-5caeb576"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "multi-select-dropdown",
  ref: "dropdown"
}
const _hoisted_2 = ["tabindex"]
const _hoisted_3 = { class: "chips-container" }
const _hoisted_4 = ["title"]
const _hoisted_5 = { class: "chip-remove" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = {
  key: 0,
  class: "placeholder"
}
const _hoisted_8 = { class: "arrow" }
const _hoisted_9 = ["placeholder"]
const _hoisted_10 = { key: 0 }
const _hoisted_11 = ["value"]
const _hoisted_12 = {
  key: 1,
  class: "no-results"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_f_icon = _resolveComponent("f-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["input-wrapper", { disabled: _ctx.disabled }]),
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleDropdown && _ctx.toggleDropdown(...args))),
      tabindex: `${_ctx.disabled ? -1 : 0}`,
      onKeydown: _cache[1] || (_cache[1] = _withKeys(
//@ts-ignore
(...args) => (_ctx.handleKeyDown && _ctx.handleKeyDown(...args)), ["enter"]))
    }, [
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedOptionObjects, (option) => {
          return (_openBlock(), _createElementBlock("span", {
            class: "chip",
            key: option.value
          }, [
            _createElementVNode("span", {
              class: "chip-label",
              title: option.label
            }, _toDisplayString(option.label), 9, _hoisted_4),
            _createElementVNode("span", _hoisted_5, [
              _createElementVNode("img", {
                class: "theme-svg",
                src: _imports_0,
                onClick: ($event: any) => (_ctx.removeOption(option.value))
              }, null, 8, _hoisted_6)
            ])
          ]))
        }), 128)),
        (!_ctx.selectedOptions.length)
          ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.localizer.Localize("Select")), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("span", _hoisted_8, [
        _createVNode(_component_f_icon, {
          icon: "chevrondown",
          color: "var(--neutral-manatee)"
        })
      ])
    ], 42, _hoisted_2),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      (_ctx.isOpen)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "dropdown-menu",
            ref: "teleportDropdown",
            style: _normalizeStyle(_ctx.dropdownPosition)
          }, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.searchQuery) = $event)),
              placeholder: _ctx.localizer.Localize('Search_PascalCase'),
              class: "search-input"
            }, null, 8, _hoisted_9), [
              [_vModelText, _ctx.searchQuery]
            ]),
            (_ctx.filteredOptions.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredOptions, (option) => {
                    return (_openBlock(), _createElementBlock("label", {
                      key: option.value,
                      class: "dropdown-option"
                    }, [
                      _withDirectives(_createElementVNode("input", {
                        type: "checkbox",
                        value: option.value,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selectedOptions) = $event))
                      }, null, 8, _hoisted_11), [
                        [_vModelCheckbox, _ctx.selectedOptions]
                      ]),
                      _createTextVNode(" " + _toDisplayString(option.label), 1)
                    ]))
                  }), 128))
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(_ctx.localizer.Localize("NoResultsFound")), 1))
          ], 4))
        : _createCommentVNode("", true)
    ]))
  ], 512))
}